module.exports = __webpack_public_path__ + "static/img/Live Music.300db7d.png";